<template>
  <header class="index__header">
    <h1>{{ title }}</h1>
    <router-link :to="{ name: createName }" :title="$t('general.create')" class="btn btn-success btn--save">
      <font-awesome-icon icon="plus" />
      <span v-if="$te(`${entity}.actions.create`)">{{ $t(`${entity}.actions.create`) }}</span>
      <span v-else>{{ $t('general.create') }}</span>
    </router-link>
  </header>
</template>

<script>
export default {
  name: 'IndexHeader',
  props: ['title', 'createName', 'entity'],
};
</script>
